import React from 'react';
import PropTypes from 'prop-types';
import { downloadSupplierImportTemplateCsv } from '../utils/supplier-import-csv-template';

export const MATTER_IMPORT_TEMPLATE_HEADER = 'Matter Number,Matter Name,Office,Status,Client Name';

const MatterImportHelp = ({ data }) => (
  <div>
    <div className="card p-2">
      <p className="mb-2">{data.t.read('matter.import_columns_help')}</p>
      <p className="mb-2">{data.t.read('matter.import_office_help')}</p>
      <p className="mb-0 text-muted small">{data.t.read('matter.import_file_help')}</p>
    </div>
    <div className="mt-2">
      <button
        type="button"
        className="btn btn-link p-0"
        onClick={() => downloadSupplierImportTemplateCsv(MATTER_IMPORT_TEMPLATE_HEADER, 'matters-import-template.csv')}
      >
        {data.t.read('matter.import_download_template')}
      </button>
    </div>
  </div>
);

MatterImportHelp.propTypes = {
  data: PropTypes.shape({
    t: PropTypes.shape({ read: PropTypes.func.isRequired }).isRequired,
  }).isRequired,
};

export default MatterImportHelp;
